/* CUSTOM_REPEATCUSTOMER_BY_CLAUDE (ONYX 0d784aba6077, Ryan 2026-10-12)
   Settings -> Admin: Repeat Buyers - the JS half. Markup in snippets/rep-settings-repeat-buyers.liquid.
   GET/POST /admin/repeat-customer-config {windowDays, frequentAt, since}; GET /admin/repeat-customer?ref= is the dry run.
   Loaded from the server first; Save stays disabled until it loaded, so a Save can never write a value the page did not read. */
(function () {
  'use strict';
  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) { if (el) el.className = 'rep-settings__message'; }
  function plain(html) {
    var d = document.createElement('div');
    d.innerHTML = String(html || '');
    return d.textContent || '';
  }
  function line(label, value) {
    var p = document.createElement('p');
    p.style.margin = '4px 0 0';
    var b = document.createElement('strong');
    b.textContent = label + ': ';
    p.appendChild(b);
    p.appendChild(document.createTextNode(value));
    return p;
  }

  function init() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var win = document.getElementById('settings-repeatbuyers-window');
    var freq = document.getElementById('settings-repeatbuyers-frequent');
    var since = document.getElementById('settings-repeatbuyers-since');
    var btn = document.getElementById('settings-repeatbuyers-btn');
    var msg = document.getElementById('settings-repeatbuyers-msg');
    var ref = document.getElementById('settings-repeatbuyers-ref');
    var check = document.getElementById('settings-repeatbuyers-check');
    var out = document.getElementById('settings-repeatbuyers-result');
    if (!btn || !win) return;
    function apply(c) {
      win.value = c.windowDays || 60;
      freq.value = c.frequentAt || 4;
      since.value = c.since || '2026-08-30';
    }
    (async function load() {
      try {
        var d = await window.RepPortal.API.get('/admin/repeat-customer-config');
        apply(d.config || {});
        btn.disabled = false;
      } catch (e) {
        showMsg(msg, 'Could not load the current setting - reload before saving.', 'error');
      }
    })();
    btn.addEventListener('click', async function () {
      hideMsg(msg);
      var body = { windowDays: parseInt(win.value, 10), frequentAt: parseInt(freq.value, 10), since: since.value };
      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = 'Saving...';
      try {
        var res = await window.RepPortal.API.post('/admin/repeat-customer-config', body);
        apply(res.config || {});
        showMsg(msg, 'Saved.', 'success');
      } catch (e) {
        showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      } finally { btn.disabled = false; btn.textContent = orig; }
    });
    if (check) check.addEventListener('click', async function () {
      var r = String(ref.value || '').trim().toUpperCase();
      out.textContent = '';
      if (!r) { out.textContent = 'Type a deal reference first, e.g. SHOP-2141.'; return; }
      check.disabled = true;
      out.textContent = 'Checking ' + r + '...';
      try {
        var d = await window.RepPortal.API.get('/admin/repeat-customer?ref=' + encodeURIComponent(r));
        out.textContent = '';
        out.appendChild(line(r, d.words || ''));
        var o = d.openers;
        if (o) {
          out.appendChild(line('First email on this order', plain(o.firstEmail)));
          out.appendChild(line('Later emails', (o.laterEmails || []).map(plain).join('  /  ')));
          out.appendChild(line('Tracking email', plain(o.tracking)));
          out.appendChild(line('Order-received email', plain(o.orderReceived)));
        }
      } catch (e) {
        out.textContent = 'Could not check: ' + (e && e.message ? e.message : 'unknown error');
      } finally { check.disabled = false; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* END CUSTOM_REPEATCUSTOMER_BY_CLAUDE */
